import moment from 'moment';

/**
 * 「有休5日使用義務」の指定日候補（days）の変換
 * APIとは "{2026-08-30,2026-09-06}"（PostgreSQLのtext[]）形式の文字列でやり取りする
 */

/**
 * APIから受け取った指定日候補を日付文字列(YYYY-MM-DD)の配列に変換
 * "{2026-08-30,2026-09-06}" → ['2026-08-30', '2026-09-06']
 * @param days APIから受け取った日付の集合
 */
export function parseDays(days: any): string[] {
  if (!days) {
    return [];
  }
  let list = Array.isArray(days)
    ? days
    : String(days).replace(/[{}"]/g, '').split(',');

  return list
    .map((d: string) => String(d).trim())
    .filter((d: string) => d.length > 0);
}

/**
 * 日付文字列の配列をAPIへ送る形式に変換
 * ['2026-08-30', '2026-09-06'] → "{2026-08-30,2026-09-06}"、空ならnull
 * @param list 日付文字列(YYYY-MM-DD)の配列
 */
export function toDaysText(list: string[]): string {
  if (!list || list.length == 0) {
    return null;
  }
  return '{' + list.join(',') + '}';
}

/**
 * 日付1件の表示用フォーマット
 * '2026-08-30' → '8/30(日)'
 * @param d 日付文字列(YYYY-MM-DD)
 */
export function formatDay(d: string): string {
  let m = moment(d, 'YYYY-MM-DD', true);
  if (!m.isValid()) {
    return d;
  }
  return m.format('M/D') + '(' + ['日', '月', '火', '水', '木', '金', '土'][m.day()] + ')';
}

/**
 * 指定日候補の表示用フォーマット
 * "{2026-08-30,2026-09-06}" → "8/30(日)、9/6(日)"
 * @param days APIから受け取った日付の集合
 */
export function formatDays(days: any): string {
  return parseDays(days).map(d => formatDay(d)).join('、');
}
